import {
    Box,
    IconButton,
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    Portal,
    useColorModeValue,
} from "@chakra-ui/react";
import { BiChevronDown } from "react-icons/bi";
import { ProcessSpecificActions } from "./ProcessSpecificActions";

const ProcessSpecificMenu = ({
    row,
    t,
    navigate,
    openProcessPrintCaPage,
    handleAttachmentDocument,
    handleReassign,
    handleReopen,
    handlePrintLetter
}) => {
    const actions = ProcessSpecificActions(
        t,
        navigate,
        openProcessPrintCaPage,
        handleAttachmentDocument,
        handleReassign,
        handleReopen,
        handlePrintLetter
    ).filter((action) => action.visible(row.original));

    return (
        <Menu placement="bottom-start">
            <MenuButton
                as={IconButton}
                icon={<BiChevronDown />}
                aria-label={t("system.labels.actions")}
                colorScheme="blue"
                border={`solid 0.1em ${useColorModeValue("#718096", "#4A5568")}`}
                w="40px"
                h="35px"
                onClick={(e) => e.stopPropagation()}
                onDoubleClick={(e) => e.stopPropagation()}
            />
            <Portal>
                <MenuList maxHeight="300px" overflowY="auto" zIndex="dropdown">
                    {actions.map((action, index) => (
                        <MenuItem
                            key={index}
                            color={useColorModeValue("gray.700","white")}
                            icon={
                                <Box fontSize="lg" display="flex" alignItems="center">
                                    {action.icon}
                                </Box>
                            }
                            onClick={(e) => {
                                e.stopPropagation();
                                action.onClick(row);
                            }}
                        >
                            {action.label}
                        </MenuItem>
                    ))}
                </MenuList>
            </Portal>
        </Menu>
    );
};

export default ProcessSpecificMenu;
